import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "breadcrumb-wrapper"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  key: 1,
  class: "rl-color-gray1"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "shadow left",
    style: _normalizeStyle({
      width: $setup.leftShadowWidth
    })
  }, null, 4), _createElementVNode("div", {
    class: "breadcrumb-viewport",
    onMousedown: _cache[0] || (_cache[0] = (...args) => $setup.startDrag && $setup.startDrag(...args)),
    onMousemove: _cache[1] || (_cache[1] = (...args) => $setup.doDrag && $setup.doDrag(...args)),
    onMouseleave: _cache[2] || (_cache[2] = (...args) => $setup.stopDrag && $setup.stopDrag(...args))
  }, [$props.breadcrumbData.length > 0 ? (_openBlock(), _createBlock(_component_el_breadcrumb, {
    key: 0,
    "separator-class": "el-icon-arrow-right"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.breadcrumbData, (item, index) => {
      return _openBlock(), _createBlock(_component_el_breadcrumb_item, {
        key: item.name,
        class: _normalizeClass(["rl-text-body-2", index < $props.breadcrumbData.length - 1 ? '' : 'rl-fontweight-medium rl-color-black1 '])
      }, {
        default: _withCtx(() => [index === $props.breadcrumbData.length - 1 ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(item.name), 1)) : item.path === '' ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(item.name), 1)) : (_openBlock(), _createBlock(_component_router_link, {
          key: 2,
          to: item.path,
          onmousedown: "event.preventDefault ? event.preventDefault() : event.returnValue = false"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
          _: 2
        }, 1032, ["to"]))]),
        _: 2
      }, 1032, ["class"]);
    }), 128))]),
    _: 1
  })) : _createCommentVNode("", true)], 32), _createElementVNode("div", {
    class: "shadow right",
    style: _normalizeStyle({
      width: $setup.rightShadowWidth
    })
  }, null, 4)]);
}